import { useMemo } from 'react';

import { useCoinGeckoPriceSWR } from 'src/hooks/useCoinGeckoPriceSWR';
import { times } from 'src/utils/number';

import { BodyContainer, Container } from './styled';
import TokenItem from './TokenItem';

import { ReactComponent as DYDXIcon } from 'src/assets/svg/DYDX.svg';
import { ReactComponent as WethDYDXIcon } from 'src/assets/svg/WethDYDX.svg';

type TokenBalanceInfoProps = {
  currentInputAmount?: string;
};

export default function TokenBalanceInfo({ currentInputAmount }: TokenBalanceInfoProps): JSX.Element {
  const coinGeckoPrice = useCoinGeckoPriceSWR();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const displayTokenPrice = useMemo(
    () => times(currentInputAmount || '0', coinGeckoPrice.data?.dydx?.usd || '0'),
    [coinGeckoPrice.data?.dydx?.usd, currentInputAmount],
  );

  return (
    <Container>
      <BodyContainer>
        <TokenItem icon={<WethDYDXIcon />} tokenName="wethDYDX" subText="Governance Token on v3 Ethereum" amount={currentInputAmount} />
        <TokenItem icon={<DYDXIcon />} tokenName="DYDX" subText="dYdX Chain Token" amount={currentInputAmount} />
      </BodyContainer>
    </Container>
  );
}
